export const management = {
  routes: [
    // TKP-139 / tasarım s.28 md.1: sistem öneri şablonu ekranı kalktı (faz 2'de yapay zeka ile); adres panele yönlenir
    { path: "/management/template-edit", redirect: "/management/account-workspace-organization" },
    // TKP-178 md.60c: kaynak–veri eşleşmeleri ayrı ekran olarak geri geldi (karar 2026-10-05: çalışma alanı + yönetim)
    { path: "/management/datasource-data", component: () => import("../management-library-datasource-data-view") },
  ],
};

export const workspace = {
  routes: [
    // TKP-144 / tasarım s.33 md.1: çalışma alanı şablon yönetimi ekranı kalktı (faz 2'de yapay zeka ile); adres panele yönlenir
    { path: "/workspace/template-edit", redirect: "/workspace" },
    // TKP-178 md.60c
    { path: "/workspace/library/datasource-data", component: () => import("../workspace-library-datasource-data-view") },
  ],
};
